import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  wrapper: {
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    minHeight: '100vh',
  },
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2),
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(2),
      paddingTop: '90px',
    },
  },
  containerWithWarning: {
    paddingTop: '143px',
    '@media (max-width: 1024px)': {
      paddingTop: '140px',
    },
    '@media (max-width: 768px)': {
      paddingTop: '130px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '120px',
    },
    '@media (max-width: 480px)': {
      paddingTop: '130px',
    },
  },
  tabPanel: {
    width: '100%',
    gap: '16px',
    borderRadius: `0px 12px 12px 12px`,
    paddingTop: '24px',
    paddingBottom: '24px',
    backgroundColor: '#FFFFFF',
    boxShadow: '-4px 4px 16px 0px #2B2A290A',
    '@media (max-width: 899px)': {
      borderRadius: '12px',
      marginTop: theme.spacing(2),
    },
  },
  mainHeader: { left: 0 },
  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      marginBottom: theme.spacing(3),
    },
    // paddingBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  // Tabs styles
  tabsContainer: {
    marginBottom: '-1px',
    position: 'relative',
    zIndex: 1,
  },
  tabs: {
    minHeight: '52px !important',
    '& .MuiTabs-flexContainer': {
      gap: '8px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tab: {
    textTransform: 'none !important' as any,
    fontFamily: 'Poppins, sans-serif !important' as any,
    fontSize: '14px !important' as any,
    fontWeight: '600 !important' as any,
    fontStyle: 'normal !important' as any,
    lineHeight: '140% !important' as any,
    letterSpacing: '0% !important' as any,
    minWidth: '178px !important' as any,
    height: '52px !important' as any,
    minHeight: '52px !important' as any,
    padding: '16px 24px !important' as any,
    borderRadius: '8px 8px 0 0 !important' as any,
    borderBottom: 'none !important' as any,
    backgroundColor: 'rgba(255, 255, 255, 0.8) !important' as any,
    color: `${STYLE.COLOR.TEXT3} !important` as any,
    boxShadow: '3px -3px 10px 0px rgba(0, 58, 87, 0.05) !important' as any,
    '&.Mui-selected': {
      backgroundColor: `${STYLE.COLOR.WHITE} !important`,
      color: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
      paddingBottom: '17px !important',
      position: 'relative',
      zIndex: 2,
    },
    '@media (max-width: 768px)': {
      width: 'auto !important',
      minWidth: 'auto !important',
      padding: '12px 16px !important' as any,
    },
  },

  // Dropdown styles for mobile
  tabDropdown: {
    width: '100%' + '!important',
    border: `1px solid #D1D5DB` + '!important',
    borderRadius: '12px' + '!important',
    justifyContent: 'space-between' + '!important',
    padding: '14px 16px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    fontWeight: 500 + '!important',
    fontSize: '14px' + '!important',
    lineHeight: '100%' + '!important',
    textTransform: 'none !important' as any,
    backgroundColor: STYLE.COLOR.WHITE + '!important',
  },

  dropdownMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid #D1D5DB`,
      borderRadius: theme.spacing(1),
      width: '100%',
      padding: '0px 12px',
      marginTop: '8px',
    },
  },

  dropdownMenuItem: {
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    minHeight: '36px' + '!important',
    paddingLeft: '8px' + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
  },
}));
